import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Table, { TableHead, TableBody, TableCell, TableRow } from "material-ui/Table";
import Typography from "material-ui/Typography";
import ArrowRight from "../Icons/ArrowRight";

const styles = () => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
  },

  guide: {
    boxShadow: '0px 0px 10px #00000026',
    borderRadius: '5px',
    padding: '55px 40px',
    marginBottom: '60px',
  },

  section: {
    // ヘッダを固定しているためアンカーリンクがずれてしまうため
    // marginTopでヘッダ要素分マイナスにする
    marginTop: '-135px',
    paddingTop: '200px'
  },

  about: {
    fontWeight: 'bold',
    fontSize: 17,
    letterSpacing: '0.3px',
    textIndent: '0.3px',
  },

  detail: {
    fontSize: 15,
    letterSpacing: '0.26px',
    textIndent: '0.26px',
  },

  caution: {
    marginTop: '30px',
    padding: '15px',
    color: '#181819',
    background: '#F4F5F6',
    borderRadius: '3px',
  },

  note: {
    fontSize: 13,
    letterSpacing: '0.22px',
    textIndent: '0.22px',
  },

  bold: {
    fontWeight: 'bold',
  },

  articleLink: {
    padding: '25px',
    border: '1px solid #195AFF',
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 0px 15px #0000001A',
      border: '1px solid #195AFF',
    }
  },

  link: {
    color: '#5F6368',
    textDecoration: 'none',
    paddingRight: '5px',
    cursor: 'pointer',
    '&:hover': {
      color: '#195AFF',
    }
  },

  linkText: {
    width: '620px',
  },

  square: {
    width: '36px',
    height: '36px',
    background: '#195AFF',
    textAlign: 'center',
    lineHeight: '36px',
    marginRight: '10px',
  },

  number: {
    color: '#FFFFFF',
    fontSize: 20,
  },

  heading: {
    display: 'flex',
    alignItems: 'center',
  },

  imgContainer: {
    padding: '20px 20px 15px 20px',
    background: '#F4F5F6',
    marginTop: '30px',
  },

  img: {
    width: '100%',
  },

  table: {
    marginTop: '20px',
    boxShadow: '0px 0px 6px #0000001A',
    borderRadius: '3px',
    padding: '10px 25px',
    borderCollapse: 'unset',
    fontSize: 13,
  },

  headerCell: {
    fontWeight: 'bold',
    color: '#181819',
    padding: '0 0 0 25px',
    fontSize: 13,
    letterSpacing: '0.25px',
    textIndent: '0.25px',
    '&:last-child': {
      paddingRight: '0',
    },
    '&:first-child': {
      paddingLeft: '0',
    }
  },

  rowCell: {
    padding: '10px 0 10px 25px',
    fontSize: 13,
    letterSpacing: '0.22px',
    textIndent: '0.22px',
    '&:last-child': {
      paddingRight: '0',
    },
    '&:first-child': {
      paddingLeft: '0',
    }
  },
});

class HowToSalesforce extends React.Component {
  renderHead = (subheading, body) => {
    return (
      <React.Fragment>
        <Typography variant="subheading" style={{ fontSize: 28, marginBottom: 15, letterSpacing: '0.48px', textIndent: '0.48px', lineHeight: '1.5em' }}>
          {subheading}
        </Typography>
        <Typography variant="subheading" style={{ letterSpacing: '0.26px', textIndent: '0.26px', lineHeight: '1.5em' }}>
          {body}
        </Typography>
      </React.Fragment>
    )
  }

  renderHeading = (number, about) => {
    const { classes } = this.props;
    return (
      <div className={classes.heading}>
        <div className={classes.square}>
          <span className={classes.number}>{number}</span>
        </div>
        <div className={classes.about}>{about}</div>
      </div>
    )
  }

  renderArticleLink = (about, detail, link) => {
    const { classes } = this.props;
    return (
      <div className={classes.articleLink} onClick={() => this.props.goTo(link)}>
        <div className={classes.linkText}>
          <div className={classes.about} style={{ fontSize: 15 }}>
            {about}
          </div>
          <div className={classes.detail}>
            {detail}
          </div>
        </div>
        <ArrowRight color="#195AFF" width={26} height={26} />
      </div>
    )
  }

  render() {
    const { classes } = this.props;
    if (this.props.howToMenu === 'アカウント連携方法') {
      return (
        <div className={classes.root}>
          <div className={classes.guide}>
            {this.renderHead('アカウント連携方法', 'Keyman LetterアカウントをSalesforceアカウントに連携するための方法です。Keyman Letter及びSalesforceの管理画面より、連携の手続きを進めることができます。')}
            <div className={classes.container}>
              <div className={classes.section} id="connect-account1" style={{ paddingTop: 190 }}>
                {this.renderHeading('1', '【Salesforce】連携中のユーザのユーザプロファイルを確認')}
                <div className={classes.imgContainer}>
                  <img
                    alt="connect-account1-img"
                    src={require('../../assets/images/mask-group-1@2x.png')}
                    className={classes.img}
                  />
                  <div className={classes.detail} style={{ marginTop: 25 }}>
                    ［設定］＞［ユーザ］＞［ユーザ］＞連携中Emailのプロファイルを確認
                  </div>
                </div>
                <div className={classes.detail} style={{ marginTop: 25 }}>
                  もしSalesforceユーザーがシステム管理者(System Administrator)でない場合は、以下の手順に従って、権限の変更をしてください。
                </div>
              </div>
              <div className={classes.section} id="connect-account2" style={{ paddingTop: 190 }}>
                {this.renderHeading('2', '【Salesforce】Salesforceシステム権限管理者の方に、権限設定の変更を依頼')}
                <div className={classes.caution}>
                  <div className={classes.detail} style={{ fontWeight: 'bold' }}>
                    変更を依頼する必要のある権限設定
                  </div>
                  <div className={classes.detail} style={{ marginTop: 10 }}>
                    1. リード・取引先・取引先責任者・キャンペーン・キャンペーンメンバーにカスタム項目を作成する権限
                  </div>
                  <div className={classes.detail} style={{ marginTop: 10 }}>
                    2. メタデータAPIを使用する権限
                  </div>
                  <div className={classes.detail} style={{ marginTop: 10 }}>
                    3. REST APIを使用する権限
                  </div>
                </div>
              </div>
              <div className={classes.section} id="connect-account3">
                {this.renderHeading('3', '【Salesforce】現ユーザー(システム権限管理者とは限らない)の項目レベルセキュリティの設定')}
                <div className={classes.imgContainer}>
                  <img
                    alt="connect-account3-img"
                    src={require('../../assets/images/mask-group-9@2x.png')}
                    className={classes.img}
                  />
                  <div className={classes.detail} style={{ marginTop: 20 }}>
                    ［設定］＞［オブジェクトマネージャ］＞［オブジェクト］(e.g Lead) ＞［項目とリレーション］＞［項目］(e.g Keyman Letter Id) ＞［項目レベルセキュリティ］＞現ユーザーのプロファイルの「参照可能」を有効にする
                  </div>
                  <div className={classes.note} style={{ marginTop: 5 }}>
                    ※スクリーンショットでは現ユーザーとしてシステム権限管理者のクローン(System Administrator Clone)を使っています
                  </div>
                </div>
                <div className={classes.detail} style={{ marginTop: 25 }}>
                  項目レベルセキュリティの変更は複数のオブジェクト項目に対して行う必要があります。以下のテーブルを参考にしてください。
                </div>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.headerCell} style={{ minWidth: 111 }}>オブジェクト名</TableCell>
                      <TableCell className={classes.headerCell} style={{ minWidth: 106 }}>項目の表示ラベル</TableCell>
                      <TableCell className={classes.headerCell} style={{ minWidth: 155 }}>項目名</TableCell>
                      <TableCell className={classes.headerCell}>注釈</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell className={classes.rowCell}>リード</TableCell>
                      <TableCell className={classes.rowCell}>Keyman Letter Id</TableCell>
                      <TableCell className={classes.rowCell}>KLId__c</TableCell>
                      <TableCell className={classes.rowCell}>取引先・取引先責任者に連携する場合は設定必要ありません</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.rowCell}>リード</TableCell>
                      <TableCell className={classes.rowCell}>法人番号</TableCell>
                      <TableCell className={classes.rowCell}>KLCorporateNumber__c</TableCell>
                      <TableCell className={classes.rowCell}>取引先・取引先責任者に連携する場合は設定必要ありません</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.rowCell}>取引先</TableCell>
                      <TableCell className={classes.rowCell}>Keyman Letter Id</TableCell>
                      <TableCell className={classes.rowCell}>KLId__c</TableCell>
                      <TableCell className={classes.rowCell}>リードに連携する場合は設定必要ありません</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.rowCell}>取引先</TableCell>
                      <TableCell className={classes.rowCell}>法人番号</TableCell>
                      <TableCell className={classes.rowCell}>KLCorporateNumber__c</TableCell>
                      <TableCell className={classes.rowCell}>リードに連携する場合は設定必要ありません</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.rowCell}>取引先責任者</TableCell>
                      <TableCell className={classes.rowCell}>Keyman Letter Id</TableCell>
                      <TableCell className={classes.rowCell}>KLId__c</TableCell>
                      <TableCell className={classes.rowCell}>リードに連携する場合は設定必要ありません</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.rowCell}>キャンペーン</TableCell>
                      <TableCell className={classes.rowCell}>Keyman Letter Id</TableCell>
                      <TableCell className={classes.rowCell}>KLId__c</TableCell>
                      <TableCell className={classes.rowCell}></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.rowCell}>キャンペーン</TableCell>
                      <TableCell className={classes.rowCell}>注文ID</TableCell>
                      <TableCell className={classes.rowCell}>KLLetterOrderId__c</TableCell>
                      <TableCell className={classes.rowCell}></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.rowCell}>キャンペーン</TableCell>
                      <TableCell className={classes.rowCell}>FC注文ID</TableCell>
                      <TableCell className={classes.rowCell}>KLFollowCallOrderId__c</TableCell>
                      <TableCell className={classes.rowCell}></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.rowCell}>キャンペーン</TableCell>
                      <TableCell className={classes.rowCell}>注文担当者</TableCell>
                      <TableCell className={classes.rowCell}>KLOrderContactName__c</TableCell>
                      <TableCell className={classes.rowCell}></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.rowCell}>キャンペーン</TableCell>
                      <TableCell className={classes.rowCell}>発送予定日</TableCell>
                      <TableCell className={classes.rowCell}>KLShippingDate__c</TableCell>
                      <TableCell className={classes.rowCell}></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.rowCell}>キャンペーン</TableCell>
                      <TableCell className={classes.rowCell}>QRコードURL</TableCell>
                      <TableCell className={classes.rowCell}>KLQrCodeTrackingUrl__c</TableCell>
                      <TableCell className={classes.rowCell}></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.rowCell} style={{ borderBottom: 'none' }}>キャンペーンメンバー</TableCell>
                      <TableCell className={classes.rowCell} style={{ borderBottom: 'none' }}>Keyman Letter Id</TableCell>
                      <TableCell className={classes.rowCell} style={{ borderBottom: 'none' }}>KLId__c</TableCell>
                      <TableCell className={classes.rowCell} style={{ borderBottom: 'none' }}></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
              <div className={classes.section} id="connect-account4">
                {this.renderHeading('4', '【Keyman Letter】アカウント管理画面から［Salesforceと連携］')}
                <div className={classes.imgContainer}>
                  <img
                    alt="connect-account4-img1"
                    src={require('../../assets/images/Screen Shot 2023-02-20 at 12.27.00@2x.png')}
                    className={classes.img}
                  />
                  <div className={classes.detail} style={{ marginTop: 20 }}>
                    ［アカウント管理］＞［連携］＞［Salesforceと連携］
                  </div>
                </div>
                <div className={classes.imgContainer}>
                  <img
                    alt="connect-account4-img2"
                    src={require('../../assets/images/Screen Shot 2023-02-20 at 12.27.18@2x.png')}
                    className={classes.img}
                  />
                  <div className={classes.detail} style={{ marginTop: 20 }}>
                    連携ボタンを押すとSalesforceのログイン画面が開くので、ここからSalesforceへログインする
                  </div>
                </div>
              </div>
              <div className={classes.section} id="connect-account5">
                {this.renderHeading('5', '【Keyman Letter】Salesforce連携設定')}
                <div className={classes.detail} style={{ marginTop: 20 }}>
                  Salesforce連携機能を利用するには、自社リストとキーマンデータベースの少なくとも一方を設定してください。
                </div>
                <div className={classes.imgContainer}>
                  <img
                    alt="connect-account5-img1"
                    src={require('../../assets/images/Screen Shot 2023-02-20 at 14.27.32@2x.png')}
                    className={classes.img}
                  />
                  <div className={classes.detail} style={{ marginTop: 20 }}>
                    ［アカウント管理］＞［連携］＞［Salesforce連携］
                  </div>
                </div>
                <div className={classes.imgContainer}>
                  <img
                    alt="connect-account5-img2"
                    src={require('../../assets/images/Screen Shot 2023-02-20 at 14.16.14@2x.png')}
                    className={classes.img}
                  />
                  <div className={classes.detail} style={{ marginTop: 20 }}>
                    ［アカウント管理］＞［連携］＞［Salesforce連携］＞［連携設定］
                  </div>
                </div>
                <div className={classes.detail} style={{ marginTop: 25 }}>
                  連携設定画面より、画面の指示に従って設定を進めます。この設定は、後からいつでも変更することができます。
                </div>
              </div>
              <div className={classes.section} id="connect-account6" style={{ paddingTop: 190 }}>
                {this.renderHeading('6', '【Keyman Letter】アカウント管理ページに戻り、同期ボタンを押す')}
                <div className={classes.detail} style={{ marginTop: 25 }}>
                  上記のテーブルにあるすべてのオブジェクト項目を「参照可能」に設定した後、Keyman Letterアカウント管理ページに戻り、同期ボタンを押してください。同期が完了すると、Salesforceのキャンペーンに以下の形式の名称で登録されます。
                </div>
                <div className={classes.caution}>
                  <div className={classes.detail}>KeymanLetter_注文NoXX_XXXXXXXX発送予定分</div>
                  <div className={classes.detail}>KeymanLetter_フォローコール注文NoXX_XXXXXXXX発送予定分</div>
                </div>
              </div>
              <div className={classes.section} id="connect-account7">
                {this.renderHeading('7', '【Keyman Letter】注文履歴画面で同期したいレター注文を選択して［Salesforceに同期］')}
                <div className={classes.imgContainer}>
                  <img
                    alt="connect-account7-img"
                    src={require('../../assets/images/group4122@2x.png')}
                    className={classes.img}
                  />
                  <div className={classes.detail} style={{ marginTop: 25 }}>
                    ［注文履歴］にて同期したい注文から［Salesforceと同期する］を選択
                  </div>
                </div>
                <div className={classes.detail} style={{ marginTop: 25 }}>
                  注文履歴画面で［Salesforceに同期］ボタンをクリックした場合、背景で同期のジョブが実行されるため、ジョブの完了を確認することはできません。
                </div>
                <div className={classes.detail} style={{ marginTop: 20 }}>
                  ジョブのステータスを確認するためには、［マイアカウント］＞［連携］＞［Salesforceと連携］画面で同期ボタンを再度押すと、ジョブが終わるまで画面左下に「同期中」のメッセージが表示されるので、同期のステータスを確認することができます。
                </div>
                <div className={classes.detail} style={{ marginTop: 20 }}>
                  同期に失敗した際にはエラーメッセージが表示されます。
                </div>
              </div>
            </div>
          </div>
          <div className={classes.guide}>
            <Typography variant="subheading" style={{ fontSize: 28, marginBottom: 55, letterSpacing: '0.48px', textIndent: '0.48px', lineHeight: '1.5em' }}>
              連携後の運用についてはこちら
            </Typography>
            {this.renderArticleLink('キーマンデータベースのSalesforceの運用のイメージ', 'Keyman LetterアカウントをSalesforceアカウントに連携したあとの運用についての解説です。レター注文後、どのようにSalesforceにデータが連携されるかを確認いただけます。', '/how-to/salesforce/operation')}
          </div>
        </div>
      )
    } else if (this.props.howToMenu === 'レター送付のSalesforceの運用のイメージ') {
      return (
        <div className={classes.root}>
          <div className={classes.guide}>
            {this.renderHead('レター送付のSalesforceの運用のイメージ', 'Keyman LetterアカウントをSalesforceアカウントに連携したあとの運用についての解説です。レター注文後、どのようにSalesforceにデータが連携されるかを確認いただけます。')}
            <div className={classes.body}>
              <div className={classes.section} id="operation1" style={{ paddingTop: 190 }}>
                {this.renderHeading('1', '送付したいキーマンを選択し、レター送付ボタンを押す')}
                <div className={classes.imgContainer} style={{ padding: 20 }}>
                  <img
                    alt="operation1-img"
                    src={require('../../assets/images/mask-group-3@2x.png')}
                    className={classes.img}
                  />
                </div>
              </div>
              <div className={classes.section} id="operation2">
                {this.renderHeading('2', 'レター送付画面でSalesforceに同期するにチェック')}
                <div className={classes.imgContainer} style={{ padding: 20 }}>
                  <img
                    alt="operation2-img"
                    src={require('../../assets/images/group4080@2x.png')}
                    className={classes.img}
                  />
                </div>
                <div className={classes.detail} style={{ marginTop: 25 }}>
                  先に、Salesforceと連携にしておく必要があります。連携は［アカウント管理］＞［連携］から行えます。連携の詳しい方法は、下のリンクからご確認ください。
                </div>
                <div style={{ marginTop: 25 }}>
                  {this.renderArticleLink('アカウント連携方法', 'Keyman LetterアカウントをSalesforceアカウントに連携するための方法です。Keyman Letter及びSalesforceの管理画面より、連携の手続きを進めることができます。', '/how-to/salesforce/connect-account')}
                </div>
              </div>
              <div className={classes.section} id="operation3">
                {this.renderHeading('3', '注文を確定')}
              </div>
              <div className={classes.section} id="operation4">
                {this.renderHeading('4', '注文履歴に「Salesforceと同期中」と表示されているのを確認')}
                <div className={classes.imgContainer} style={{ padding: 20 }}>
                  <img
                    alt="operation4-img"
                    src={require('../../assets/images/mask-group-2@2x.png')}
                    className={classes.img}
                  />
                </div>
              </div>
              <div className={classes.section} id="operation5">
                {this.renderHeading('5', 'Salesforce上で同期されているのを確認')}
                <div className={classes.detail} style={{ marginTop: 25 }}>
                  注文後しばらくすると、Salesforceに同期されます。以下の画面キャプチャではリードに登録されましたが、取引先/取引先責任者へ登録設定も可能です。Keyman Letter IdがあるデータはKeyman Letterより同期したデータとなります。
                </div>
                <div className={classes.imgContainer} style={{ padding: 20 }}>
                  <img
                    alt="operation5-img1"
                    src={require('../../assets/images/group-2@2x.png')}
                    className={classes.img}
                  />
                </div>
                <div className={classes.imgContainer}>
                  <img
                    alt="operation5-img2"
                    src={require('../../assets/images/group-1@2x.png')}
                    className={classes.img}
                  />
                  <div className={classes.detail} style={{ marginTop: 20 }}>
                    詳細ページにキャンペーンが作成されています。
                  </div>
                </div>
                <div className={classes.imgContainer}>
                  <img
                    alt="operation5-img3"
                    src={require('../../assets/images/Untitledq@2x.png')}
                    className={classes.img}
                  />
                  <div className={classes.detail} style={{ marginTop: 20 }}>
                    キャンペーン詳細画面です。
                  </div>
                </div>
              </div>
              <div className={classes.section} id="operation6">
                {this.renderHeading('6', 'QRコードの読み込みがあった場合')}
                <div className={classes.detail} style={{ marginTop: 25 }}>
                  レターにQRコードを設定していて、受取人がQRの読み込みをするとキャンペーンの状況が「レスポンスあり」へ自動で変更されます。
                </div>
                <div className={classes.imgContainer}>
                  <img
                    alt="operation6-img"
                    src={require('../../assets/images/group4050@2x.png')}
                    className={classes.img}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    } else if (this.props.howToMenu === 'Salesforceとのデータの重複について') {
      return (
        <div className={classes.root}>
          <div className={classes.guide}>
            {this.renderHead('Salesforceとのデータの重複について', 'Keyman LetterアカウントとSalesforceのデータが重複した場合を解説します。')}
            <div className={classes.body}>
              <div className={classes.section} id="duplication1" style={{ paddingTop: 190 }}>
                {this.renderHeading('1', 'レター送付先のキーマンが自社リストと重複する場合について')}
                <div className={classes.detail} style={{ marginTop: 25 }}>
                  レターを送付する際、新規でアプローチする人がほとんどかと思われますので貴社のリードや取引先責任者と重複するケースは少ないと思われます。<br />
                  しかし、もし重複している方にレターを送りたい場合は、SalesforceのデータをKeyman Letterへ同期する機能を利用してください。同期した後、自社リストからレターを送付してください。<br />
                  SalesforceのデータをKeyman Letterへ同期する方法は<span className={classes.link} onClick={() => this.props.goTo('/how-to/salesforce/connect-account')}> アカウント連携</span>をご参照ください。
                </div>
              </div>
              <div className={classes.section} id="duplication2">
                {this.renderHeading('2', 'Salesforceと同期した後、Salesforceで新規の登録データが重複する場合について')}
                <div className={classes.detail} style={{ marginTop: 25 }}>
                  Salesforceの設定で重複ルールを活用していただくと、重複の登録条件ルールを制限、緩和することができます。Keyman Letterのデータは「会社名」「姓」「名」を提供してますので、
                  これらを重複ルールに設定していただくと、重複した場合、Salesforce上でアラート表示や登録拒否することができます。
                </div>
                <div className={classes.imgContainer} style={{ padding: 20 }}>
                  <img
                    alt="salesforce-duplication-rule-img"
                    src={require('../../assets/images/salesforce-duplication-rule.png')}
                    className={classes.img}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return;
    }
  }
}

HowToSalesforce.propTypes = {
  classes: PropTypes.object.isRequired,
  goTo: PropTypes.func.isRequired,
  howToMenu: PropTypes.string.isRequired,
};

export default withStyles(styles)(HowToSalesforce);



// WEBPACK FOOTER //
// ./src/components/Faq/HowToSalesforce.jsx